import {default as _} from 'lodash';
import { Component, ViewChild, Input, OnInit, SimpleChanges } from "@angular/core";
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import {default as GridColumnsJSON} from 'app/Pages/cat-dashboard/finra-exception/finra-exception-summary/finra-exception-summary-grid-columns.json';
import { MessageService } from 'primeng/api';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from "app/Shared/Services/constant-service";
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { GridService } from "app/Shared/Services/grid.service";
import { UserService } from "app/Shared/Services/user.service";
import { Table, TableModule } from 'primeng/table';
import { Router } from "@angular/router";
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { DecimalPipe, LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';

@Component({
    selector: 'app-finra-exception-summary',
    imports: [CommonModule, MatProgressSpinner, NgClass, TableModule, MatTooltipModule, LowerCasePipe, DecimalPipe, ExportToCSVSComponent],
    templateUrl: './finra-exception-summary.component.html',
    styleUrls: ['./finra-exception-summary.component.scss']
})
export class FinraExceptionSummaryComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table;
  @Input('defaultFilters') DefaultFilterArray: any = [];
  HTTPSubscribedExceptionSummaryAPI: any;
  HTTPSubscribedExceptionSummaryDetailAPI: any;
  subscription!: Subscription;
  selectedExceptionCode: any = '';
  tbldatamsg: string = 'No data found';
  isSummaryDataLoading: boolean = false;
  isDataLoading: boolean = false;
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  pageNumber: any = 1;
  Limit: any = { 'Start': '', 'End': '' };
  sortData:any = { field: '', order: 0};
  sortClickCounter: number = 0;
  excpSummaryCols: any = [];
  excpSummaryGridColumns: any = GridColumnsJSON["exceptionSummaryColumns"];
  excpSummaryExportableGridColumns: any = this.excpSummaryGridColumns.filter((rowObj: any) => rowObj.display==='true');
  exceptionCodesSummaryBlocks: any = [];
  defaultColumnGroupBy: any = [{"failureCode": "NA", "Error_Code_GroupBy_Fields": "failureCode", "totalCount": 0}];
  excpSummaryTotalRecords: number = 0;
  excpSummaryDataSet: any = [];

  constructor(public gridService: GridService,
    public constantService: ConstantService,
    public userService: UserService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private emitterService: EmitterService,
    private messageService: MessageService,
    private sortPipe: SortPipe,
    private router: Router) {
  }

  ngOnInit() {
    this.isDataLoading = false;
    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.endLimit = this.constantService.DEFAULT_ROWSIZE;
    this.Limit = { 'Start': '0', 'End': this.endLimit };
    this.getColumns();
    this.resetGridTableColumnDisplay(); // Make invisible all Group By Columns by default
    this.getExceptionSummaryData();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe({
      next: (value:any) => {
      if (value) {
        this.initLoadingFunctions(); // Initialize Page's necessary Functions
      }
    }});
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initLoadingFunctions(); // Initialize Page's necessary Functions
  }

  initLoadingFunctions() {
    this.resetGridTableColumnDisplay(); // Make invisible all Group By Columns by default

    this.endLimit = this.rowcount;
    this.Limit = { 'Start': '0', 'End': this.endLimit };

    this.selectedExceptionCode = '';
    this.excpSummaryTotalRecords = 0;
    this.excpSummaryTotalRecords = this.gridService.handleNoRecordsPageNumber(this.excpSummaryTotalRecords);
    this.excpSummaryDataSet = [];

    this.getExceptionSummaryData();
  }

  getColumns() {
    let column: any = this.excpSummaryGridColumns;
    if (column != null || column != undefined) {
      this.excpSummaryCols = this.gridService.getGridColumns(column);
    }
  }

  changePage(event: any) {
    this.startLimit = event.first;
    this.rowcount = event.rows;

    this.endLimit = this.startLimit + this.rowcount;

    if (this.endLimit > this.excpSummaryTotalRecords) {
      this.endLimit = this.excpSummaryTotalRecords;
    }

    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;

    this.getExceptionData(this.selectedExceptionCode, false);
  }

  sort(event: any) {
    if(this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if(this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.excpSummaryDataSet = this.sortPipe.transform(this.excpSummaryDataSet, this.sortData.order, this.sortData.field);
    } else {
     if(this.dt.multiSortMeta != undefined && this.dt.multiSortMeta?.length > 0) {
      this.dt.multiSortMeta[0].field = '';
      this.dt.multiSortMeta[0].order = 0;
     }
    }
  }

  getExceptionSummaryData() {
    // Cancel All Previously Pending Exception Summary APIs
    if (this.HTTPSubscribedExceptionSummaryAPI) {
      this.HTTPSubscribedExceptionSummaryAPI.unsubscribe();
    }

    this.isSummaryDataLoading = true;

    const filterParams = this.prepareSearchParameters();

    this.HTTPSubscribedExceptionSummaryAPI = this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.FINRA_EXCEPTION_SUMMARY
      ), filterParams)
    .subscribe({
      next: (Element:any) => {
      let dataset: any = Element;
      this.exceptionCodesSummaryBlocks = dataset.Data ? dataset.Data : [];

      this.isSummaryDataLoading = false;
    }, error: (err: HttpErrorResponse) => {
      this.isSummaryDataLoading = false;
    }});
  }

  prepareSearchParameters() {
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(this.DefaultFilterArray[0].values[0]);
    filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(this.DefaultFilterArray[0].values[1]);

    let filterParams = {
      CATReporterIMID: this.userService.getActiveMPID(),
      data: filterData
    };

    return filterParams;
  }

  /* Make invisible all Group By Columns by default */
  resetGridTableColumnDisplay() {
    let AllGroupByColumns: any = _.uniq(_.reduce(this.exceptionCodesSummaryBlocks, function (acc: any, obj: any) {
                                    acc.push(obj.Error_Code_GroupBy_Fields);
                                    return acc;
                                  }, []));

    for(let i=0; i < AllGroupByColumns.length; i++) {
      let AllGroupByFields = AllGroupByColumns[i].split(", ");
      for(let j=0; j < AllGroupByFields.length; j++) {
        for(let k=0; k < this.excpSummaryCols.length; k++) {
          if(this.excpSummaryCols[k].field === AllGroupByFields[j]) {
            this.excpSummaryCols[k].display = "false";
          }
        }
      }
    }
    /* Apply visibility updates in Exportable Grid Columns */
      for(let i=0; i < AllGroupByColumns.length; i++) {
        let AllGroupByFields = AllGroupByColumns[i].split(", ");
        for(let j=0; j < AllGroupByFields.length; j++) {
          for(let k=0; k < this.excpSummaryGridColumns.length; k++) {
            if(this.excpSummaryGridColumns[k].mappingkey === AllGroupByFields[j]) {
              this.excpSummaryGridColumns[k].display = "false";
            }
          }
        }
      }
      this.excpSummaryExportableGridColumns = [...this.excpSummaryGridColumns.filter((rowObj: any) => rowObj.display==='true')];
    /* End of Applying visibility updates in Exportable Grid Columns */
  }

  // Display opted Exception Code Columns in Exception Summary Grid Table
  displayOptedExceptionCodeColumns(optedExceptionCodecolumnGroupBy: any) {
    if(optedExceptionCodecolumnGroupBy.length > 0) {
      let columnGroupByFields = optedExceptionCodecolumnGroupBy[0].Error_Code_GroupBy_Fields.split(", ");
      if(columnGroupByFields.length > 0) {
        for(let l=0; l < columnGroupByFields.length; l++) {
          for(let m=0; m < this.excpSummaryCols.length; m++) {
            if(this.excpSummaryCols[m].field === columnGroupByFields[l]) {
              this.excpSummaryCols[m].display = "true";
              break;
            }
          }
        }
        /* Apply visibility updates in Exportable Grid Columns */
          for(let l=0; l < columnGroupByFields.length; l++) {
            for(let m=0; m < this.excpSummaryGridColumns.length; m++) {
              if(this.excpSummaryGridColumns[m].mappingkey === columnGroupByFields[l]) {
                this.excpSummaryGridColumns[m].display = "true";
                break;
              }
            }
          }
          this.excpSummaryExportableGridColumns = [...this.excpSummaryGridColumns.filter((rowObj: any) => rowObj.display==='true')];
        /* End of Applying visibility updates in Exportable Grid Columns */
      }
    }
  }

  // Reset Paging to First Page
  resetPageing() {
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.endLimit = this.startLimit + this.rowcount;

    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.pageNumber = 1;
    this.dt.first = this.startLimit;
  }

  getExceptionData(optedExceptionCode: any, isResetPaging: boolean) {
    // Cancel All Previously Pending Exception Summary Detail APIs
    if (this.HTTPSubscribedExceptionSummaryDetailAPI) {
      this.HTTPSubscribedExceptionSummaryDetailAPI.unsubscribe();
    }

    // Reset Paging to First Page
    if(isResetPaging) {
      this.resetPageing();
    }

    this.resetGridTableColumnDisplay(); // Make invisible all Group By Columns by default

    /* Make visible User's Chosen Exception Code Group-By-Columns on Exception Summary Detail Grid Table */
    let columnGroupBy = this.exceptionCodesSummaryBlocks.filter((rowObj: { failureCode: any; }) => rowObj.failureCode === optedExceptionCode);
    if(columnGroupBy[0].Error_Code_GroupBy_Fields.length > 0) {
      this.displayOptedExceptionCodeColumns(columnGroupBy); // Display opted Exception Code Columns in Exception Summary Grid Table
    } else if(columnGroupBy[0].Error_Code_GroupBy_Fields.length===0) {
      columnGroupBy = this.defaultColumnGroupBy;
      this.displayOptedExceptionCodeColumns(columnGroupBy); // Display opted Exception Code Columns in Exception Summary Grid Table
    }
    /* End of Making visible User's Chosen Exception Code Group-By-Columns on Exception Summary Detail Grid Table */

    this.selectedExceptionCode = optedExceptionCode;

    this.isDataLoading = true;

    const filterParams = this.prepareSearchParameters();
    Object.assign(filterParams, {optedExceptionCode: optedExceptionCode, optedExceptionCodeGroupBy: (columnGroupBy.length > 0 ? columnGroupBy[0].Error_Code_GroupBy_Fields : undefined), startLimit: this.Limit.Start.toString(), endLimit: this.Limit.End.toString()});

    /* Catch User Action Log */
      this.userService.logUserActivity("User applied Filter Code", "Finra-Exception-Summary", {
        'Text1': this.userService.userFirstName + ' applied Filter Code: ' + optedExceptionCode,
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterParams)
      });

    this.HTTPSubscribedExceptionSummaryDetailAPI = this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.FINRA_EXCEPTION_CODE_SUMMARY_DETAIL
      ), filterParams)
    .subscribe({
      next: (Element:any) => {
      let dataset: any = Element;
      this.excpSummaryTotalRecords = dataset.totalCount;
      this.excpSummaryDataSet = dataset.Data ? dataset.Data : [];

      this.excpSummaryTotalRecords = this.gridService.handleNoRecordsPageNumber(this.excpSummaryTotalRecords);
      if (this.excpSummaryTotalRecords === 0) {
        this.tbldatamsg = "No data found";
      }
      this.isDataLoading = false;
    },error: (err: HttpErrorResponse) => {
      this.isDataLoading = false;
      this.excpSummaryTotalRecords = 0;
      this.excpSummaryTotalRecords = this.gridService.handleNoRecordsPageNumber(this.excpSummaryTotalRecords);
      this.excpSummaryDataSet = [];
    }});
  }

  onDisplayOrderDetail(orderType: any, rowData: any) {
    if(orderType==='Open-Order-Popup') {
      this.emitterService.isOrderViewerOpenCloseEvent.emit({
        display: true,
        rowData: rowData,
        pageName: 'CAT-ROE'
      });
    } else if(orderType==='Open-Finra-Exception-Detail-Screen') {
      let initialReportDate, endReportDate;

      initialReportDate = this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.DefaultFilterArray[0].values[0]));
      endReportDate = this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.DefaultFilterArray[0].values[1]));

      let urlParams: any = {
        "callFromScreen": "finraexceptionsummary",
        "activeMPID": this.userService.getActiveMPID(),
        "reportDate": [initialReportDate, endReportDate],
        "failureCode": rowData.failureCode,
        "status": "Open"
      };
      // Add `actualValue` property conditionally
      if (rowData.actualValue!=undefined && rowData.actualValue.length > 0) {
        urlParams.actualValue = rowData.actualValue;
      } else if (rowData.actualValue!=undefined && rowData.actualValue.length===0) {
        urlParams.actualValue = " ";
      }

      /* Catch User Action Log */
        this.userService.logUserActivity("Reviewed Finra-Exception Records", null, {
          'Text1': this.userService.userFirstName + ' reviewed Finra-Exception records from Finra-Exception-Summary',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(urlParams)
        });

      this.router.navigate([]).then(result => {  window.open('/#/pages/CAT/Finra-Exception?'+btoa(JSON.stringify(urlParams)), '_blank'); });
    }
  }

  exportToCSV(event: any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});

    // to let user know the button is clicked and download process is started
    this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_INFO, summary: this.constantService.MESSAGE_SUMMARY_INFO, detail: 'Please wait.. Preparing export file to download..' });

    /* Receive User's Chosen Exception Code Group-By-Columns on Exception Summary Detail Grid Table */
      let columnGroupBy = this.exceptionCodesSummaryBlocks.filter((rowObj: { failureCode: any; }) => rowObj.failureCode === this.selectedExceptionCode);
       if(columnGroupBy[0].Error_Code_GroupBy_Fields.length > 0) {
      } else if(columnGroupBy[0].Error_Code_GroupBy_Fields.length===0) {
        columnGroupBy = this.defaultColumnGroupBy;
      }
    /* End of Receiving visible User's Chosen Exception Code Group-By-Columns on Exception Summary Detail Grid Table */

    const filterParams = this.prepareSearchParameters();
    Object.assign(filterParams, {optedExceptionCode: this.selectedExceptionCode, optedExceptionCodeGroupBy: (columnGroupBy.length > 0 ? columnGroupBy[0].Error_Code_GroupBy_Fields : undefined), startLimit: ((event.isExportMaxRows) ? this.constantService.NUMBER_0 : this.Limit.Start.toString()), endLimit: ((event.isExportMaxRows) ? this.constantService.NUMBER_MAX_EXPORT_ROWS : this.Limit.End.toString())});

    this.HTTPSubscribedExceptionSummaryDetailAPI = this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.FINRA_EXCEPTION_CODE_SUMMARY_DETAIL
      ), filterParams)
    .subscribe({
      next: (Element:any) => {
      let dataset: any = Element;

      let data = ((!event.isExportMaxRows) ? this.excpSummaryDataSet : dataset.Data);
        if(data.length > 0) {
          const options: any = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: 'RSMS_FINRA_Exception_Summary_' + this.userService.getyyyyMMddDateFormate(new Date()),
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
            filename: this.userService.getActiveMPID() +'_RSMS_FINRA_Exception_Summary_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
          };
          const csvData = this.constantService.getExportData(data, event.gridColumn);
          const csv = generateCsv(options)(csvData);
          const blob = asBlob(options)(csv);
          saveAs(blob,options.filename);
  
          this.userService.logUserActivity('Export CSV - Finra Exception Summary', null, {
            'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
            'Text2': 'User Filter Parameters: ' + JSON.stringify(filterParams.data.filter((filterParam: any) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
          this.userService.logUserActivity('Export CSV - Finra Exception Summary', null, {
            'Text1': 'No data found',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(filterParams.data.filter((filterParam: any) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
        this.emitterService.exportToCSVData.emit(true);
    }, error: (err: HttpErrorResponse) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
      this.userService.logUserActivity('Export CSV - Finra Exception Summary', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterParams.data.filter((filterParam: any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }});

  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
 
}